import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { Flow } from '@/types/flow.type';

import { FlowsSliceState } from './flows.type';

const flowsInitialState: FlowsSliceState = {
    data: [],
};

export const FLOWS_REDUCER_NAME = 'flows';

export const flowsSlice = createSlice({
    name: FLOWS_REDUCER_NAME,
    initialState: flowsInitialState,
    reducers: {
        setFlows: (
            state,
            action: PayloadAction<{
                flows: Flow[];
            }>,
        ) => {
            state.data = action.payload.flows;
        },
        renameFlow: (
            state,
            action: PayloadAction<{ flowCode: string; name: string }>,
        ) => {
            const flow = state.data.find(
                (flow) => flow.code === action.payload.flowCode,
            );

            if (flow) {
                flow.name = action.payload.name;
            }
        },
    },
});

export const { setFlows, renameFlow } = flowsSlice.actions;

export const flowsReducer = flowsSlice.reducer;
